class MessageBusService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8888";
  }

  async postFormData(endpoint, formData) {
    const response = await fetch(`${this.apiUrl}${endpoint}`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Server error: ${response.status} - ${text}`);
    }

    return response.json();
  }

  async postJson(endpoint, payload) {
    const response = await fetch(`${this.apiUrl}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Server error: ${response.status} - ${text}`);
    }

    return response.json();
  }

  async sendSensorFrameWithTranscriptToMessageBus(
    imageData,
    transcript,
    sessionId,
    nickname = null
  ) {
    if (!imageData && !transcript) {
      throw new Error("Both image and transcript cannot be empty");
    }

    const formData = new FormData();

    if (imageData) {
      if (imageData instanceof Blob) {
        formData.append("image", imageData, "photo.png");
      } else if (
        typeof imageData === "string" &&
        imageData.startsWith("data:")
      ) {
        formData.append("imageData", imageData);
      }
    }

    formData.append("transcript", transcript || "");
    formData.append("sessionId", sessionId || "");
    formData.append("nickname", nickname || "");

    return this.postFormData("/api/publish/sensor_with_transcript", formData);
  }

  async sendAudioForTranscription(audioBlob, sessionId, nickname = null) {
    if (!audioBlob) {
      return null;
    }

    const formData = new FormData();
    formData.append("audio", audioBlob, "recording.webm");
    formData.append("type", "audio_captured");
    formData.append("sessionId", sessionId || "");
    formData.append("timestamp", Date.now());
    formData.append("source", "qr-code-page");
    formData.append("nickname", nickname || "");

    const response = await this.postFormData("/api/publish/audio", formData);
    return response?.success ? response.result : null;
  }

  async sendGyroscopeDataToMessageBus(
    orientation,
    sessionId,
    nickname = null
  ) {
    if (!orientation || !sessionId) {
      return null;
    }

    const response = await this.postJson("/api/publish/gyroscope", {
      sessionId,
      nickname: nickname || "",
      alpha: orientation.alpha ?? null,
      beta: orientation.beta ?? null,
      gamma: orientation.gamma ?? null,
      absolute: orientation.absolute ?? null,
    });

    return response?.success ? response.result : null;
  }
}

const messageBusService = new MessageBusService();

export default messageBusService;
